import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="heading,text,image" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' isPrimaryBtn homeZigZag className="home-zigzag-comp-padding Adobe-PDF-Services-API ms-zigzag-cta-one zigzag-align zig-zag-cont-one" mdxType="TextBlock" />
    <h3 {...{
      "id": "improve-pdf-accessibility-for-all-users"
    }}>{`Improve PDF accessibility for all users`}</h3>
    <p>{`Improve the user experience for all stakeholders, including employees, customers, citizens, or students who leverage screen readers with accurate auto-tagging - this applies to documents created internally as well as externally or by third parties.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "690px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/a2134f42f32255376b304e9d86a5b309/5530d/improvePDFAccessibility.webp 320w", "/document-services/static/a2134f42f32255376b304e9d86a5b309/0c8fb/improvePDFAccessibility.webp 640w", "/document-services/static/a2134f42f32255376b304e9d86a5b309/ffce4/improvePDFAccessibility.webp 690w"],
            "sizes": "(max-width: 690px) 100vw, 690px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/a2134f42f32255376b304e9d86a5b309/8980b/improvePDFAccessibility.jpg 320w", "/document-services/static/a2134f42f32255376b304e9d86a5b309/56d4e/improvePDFAccessibility.jpg 640w", "/document-services/static/a2134f42f32255376b304e9d86a5b309/7efee/improvePDFAccessibility.jpg 690w"],
            "sizes": "(max-width: 690px) 100vw, 690px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/a2134f42f32255376b304e9d86a5b309/7efee/improvePDFAccessibility.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image,heading,text" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' isPrimaryBtn homeZigZag className="home-zigzag-comp-padding Adobe-PDF-Services-API ms-zigzag-cta-one zigzag-align zig-zag-cont-two" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "662px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "64.6875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/da12bdb20639c1a5abae4faab9ef15f8/5530d/remediateEasily.webp 320w", "/document-services/static/da12bdb20639c1a5abae4faab9ef15f8/0c8fb/remediateEasily.webp 640w", "/document-services/static/da12bdb20639c1a5abae4faab9ef15f8/82a5e/remediateEasily.webp 662w"],
            "sizes": "(max-width: 662px) 100vw, 662px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/da12bdb20639c1a5abae4faab9ef15f8/8980b/remediateEasily.jpg 320w", "/document-services/static/da12bdb20639c1a5abae4faab9ef15f8/56d4e/remediateEasily.jpg 640w", "/document-services/static/da12bdb20639c1a5abae4faab9ef15f8/3eed4/remediateEasily.jpg 662w"],
            "sizes": "(max-width: 662px) 100vw, 662px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/da12bdb20639c1a5abae4faab9ef15f8/3eed4/remediateEasily.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "remediate-easily-at-scale"
    }}>{`Remediate easily at scale`}</h3>
    <p>{`Tagging PDFs can often be slow, manual, and error prone. Make your documents more inclusive at scale and avoid picking and choosing which documents to remediate.`}</p>
    <TextBlock slots="heading,text,image" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' isPrimaryBtn homeZigZag className="home-zigzag-comp-padding Adobe-PDF-Services-API ms-zigzag-cta-one zigzag-align zig-zag-cont-three" mdxType="TextBlock" />
    <h3 {...{
      "id": "move-toward-compliance-with-greater-ease"
    }}>{`Move toward compliance with greater ease`}</h3>
    <p>{`Automation leads to more efficient remediation. Reduce legal risk while lowering the overhead and resources you may need to move toward compliance with certain accessibility standards.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "612px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/03232a5c2ca8c4ed72eb867af9ab2f1b/5530d/lessEffort.webp 320w", "/document-services/static/03232a5c2ca8c4ed72eb867af9ab2f1b/d408e/lessEffort.webp 612w"],
            "sizes": "(max-width: 612px) 100vw, 612px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/03232a5c2ca8c4ed72eb867af9ab2f1b/8980b/lessEffort.jpg 320w", "/document-services/static/03232a5c2ca8c4ed72eb867af9ab2f1b/6c4e2/lessEffort.jpg 612w"],
            "sizes": "(max-width: 612px) 100vw, 612px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/03232a5c2ca8c4ed72eb867af9ab2f1b/6c4e2/lessEffort.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      